import axios from "axios";

export function loadArticlesApi(payload) {
    const { sectionId, page } = payload;
    return axios.get(`https://heuguchon.zendesk.com/api/v2/help_center/ko/sections/${sectionId}/articles?per_page=10&page=${page}`);
}

export function loadArticleApi(id) {
    return axios.get(`https://heuguchon.zendesk.com/api/v2/help_center/ko/articles/${id}`);
}